// src/utils/utils_whatsapp.ts
//
// Identifiant WhatsApp = numéro de téléphone. Ce fichier est le miroir exact de
// WhatsAppSender::toInternationalNumber côté admin-api : mêmes formes acceptées,
// mêmes bornes. Il ne remplace pas la validation serveur — il évite seulement
// d'expédier vers Meta un numéro dont on sait déjà qu'il sera refusé, et de faire
// lire à l'opérateur un message d'erreur écrit par Meta.
//
// Doit rester le miroir de WhatsAppSender : toute règle ajoutée là-bas se
// réplique ici, sans quoi le front laisserait passer ce que le serveur refuse.

/** Indicatif appliqué à un numéro saisi au format national (« 06 12 34 56 78 »). */
export const INDICATIF_PAR_DEFAUT = '33';

/** Bornes E.164 : 8 chiffres au minimum, 15 au maximum indicatif compris. */
const LONGUEUR_MIN = 8;
const LONGUEUR_MAX = 15;

/**
 * Numéro au format attendu par WhatsApp : chiffres seulement, indicatif compris.
 *
 * @returns Le numéro normalisé, ou null s'il est inexploitable.
 */
export const normalizeWhatsappNumber = (valeur: string): string | null => {

  const saisie = valeur.trim();

  if (saisie === '') { return null; }

  const commencePlus = saisie.startsWith('+');

  let chiffres = saisie.replace(/\D+/g, '');

  if (chiffres === '') { return null; }

  if (!commencePlus) {
    if      (chiffres.startsWith('00')) { chiffres = chiffres.slice(2); }
    // Le 0 initial est un préfixe d'accès local, pas un chiffre du numéro :
    // il cède la place à l'indicatif.
    else if (chiffres.startsWith('0') ) { chiffres = INDICATIF_PAR_DEFAUT + chiffres.slice(1); }
  }

  if (chiffres.length < LONGUEUR_MIN || chiffres.length > LONGUEUR_MAX) { return null; }

  return chiffres;
};

/** Le numéro est-il exploitable par WhatsApp ? */
export const isValidWhatsappNumber = (valeur: string): boolean =>
  normalizeWhatsappNumber(valeur) !== null;
